export function getAdminTeamAccount(context: ResolverContext) {
  throw new Error('getAdminTeamAccount called on the client!');
}

export function getAdminTeamAccountId() {
  throw new Error('getAdminTeamAccountId called on the client!');
}
